import * as React from 'react';
import { EntityType } from "../../../entities/common";
import TagLink from '../TagLink';
import { Console } from 'console';

export class TagFormatter extends React.Component<{ value?: string[], withNavigation: boolean, entityType?: EntityType }>{
    render() {
        const { value, withNavigation, entityType } = this.props;
        if (!value) {
            return null;
        }
        if (!Array.isArray(value)) {
            console.error(`Tag value ${value} is not an array`);
            return value;
        }

        return <div className="tags" title={value?.join(" ")}>
            {value.map((item, index) => <TagLink key={index} value={item} entityType={entityType} withoutNavigation={!withNavigation} />)}
        </div>;
    }
}
